import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";

const GraffitiHeader = ({
  mainText = "NOTICIAS",
  backgroundText = "NOTICIAS",
  height = "230px",
  width = "100%",
  mainColor = "#ffffff",
  graffitiColor = "#ff6f00",
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        width,
        height,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "visible",
        mb: 2,
      }}
    >
      {/* Graffiti gigante de fondo */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9, rotate: -8 }}
        animate={{ opacity: 1, scale: 1, rotate: -6 }}
        transition={{ duration: 1 }}
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          pointerEvents: "none",
          userSelect: "none",
          zIndex: 0,
        }}
      >
        <Typography
          sx={{
            fontFamily: "Impact, sans-serif",
            fontSize: {
              xs: "5rem",
              md: "10rem",
            },
            color: graffitiColor,
            opacity: 0.05,
            letterSpacing: "10px",
            whiteSpace: "nowrap",
            textTransform: "uppercase",
          }}
        >
          {backgroundText}
        </Typography>
      </motion.div>

      {/* Título principal */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          duration: 0.7,
          delay: 0.2,
        }}
        style={{
          position: "relative",
          zIndex: 2,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontFamily: "Impact, sans-serif",
            fontSize: {
              xs: "3rem",
              md: "5rem",
            },
            color: mainColor,
            textAlign: "center",
            textTransform: "uppercase",
            textShadow: "3px 3px 10px rgba(0,0,0,.7)",
            letterSpacing: "2px",
          }}
        >
          {mainText}
        </Typography>
      </motion.div>
    </Box>
  );
};

export default GraffitiHeader;